import React from 'react';
import { Col, Progress, Row } from '../Bootstrap';
import './BarList.scss';

export class BarList extends React.Component<any, any> {
  renderRow = (row, key) => {
    return (
      <div className='w-100'>
        <Row className='d-none d-md-flex' key={key}>
          <Col xs={5}>{row.name}</Col>
          <Col xs={5}>
            <Progress value={Math.round(row.progressValue * 100)} />
          </Col>
          <Col xs={2} className='text-right'>
            {row.value}
          </Col>
        </Row>
        <div className='d-md-none bar-list-mobile-row'>
          <div className='d-flex align-items-end mb-2 justify-content-between'>
            <span className='bar-list-mobile-name'>{row.name}</span>
            <span className='bar-list-mobile-price'>{row.value}</span>
          </div>
          <Progress value={Math.round(row.progressValue * 100)} />
        </div>
      </div>
    );
  };

  render() {
    return <div className='bar-list'>{this.props.data.map(this.renderRow)}</div>;
  }
}
